interface Props { onSelect: (lang: 'de' | 'en') => void; onBack?: () => void }

export function LanguageSelection({ onSelect, onBack }: Props) {
  return (
    <div className="tembo-demo-overlay">
      <div className="tembo-demo-content">
        {onBack && (
          <button className="back-btn" onClick={onBack}>
            ← Zurück / Back
          </button>
        )}
        <img src="/images/logo.png" alt="TEMBO Logo" className="tembo-logo" />
        <div className="welcome-title">Willkommen / Welcome</div>
        <div className="welcome-subtitle">
          Bitte wähle deine bevorzugte Sprache / Please select your preferred language
        </div>
        <div className="language-selection-buttons">
          <button className="language-btn" onClick={() => onSelect('de')}>
            <div className="language-btn-text">Deutsch</div>
          </button>
          <button className="language-btn" onClick={() => onSelect('en')}>
            <div className="language-btn-text">English</div>
          </button>
        </div>
      </div>
    </div>
  )
}
